import AccountIcon from './AccountIcon';

export default AccountIcon;
